let chineseTextService = null
let chineseTextServiceLoad = null

export function loadChineseTextService() {
  if (chineseTextService) return Promise.resolve(chineseTextService)
  if (chineseTextServiceLoad) return chineseTextServiceLoad

  chineseTextServiceLoad = import(
    /* webpackChunkName: "chinese-text-service" */
    './chinese_text_service'
  ).then(module => {
    const ChineseTextService = module.default || module
    chineseTextService = new ChineseTextService()
    return chineseTextService
  }).catch(() => {
    // A transient chunk/network failure must not poison later card or chat use.
    chineseTextServiceLoad = null
    chineseTextService = null
    throw new Error('Chinese text module unavailable')
  })

  return chineseTextServiceLoad
}

export async function ensureChineseTextService(owner, loader = loadChineseTextService) {
  if (owner.language !== 'chinese') return null
  if (owner.chineseTextService) return owner.chineseTextService

  let service
  try {
    service = await loader()
  } catch (_error) {
    return null
  }

  // A navigation/language change while the chunk was loading must not attach a
  // Chinese service to a different chat.
  if (owner.language !== 'chinese') return null

  owner.chineseTextService = service
  owner.readingAidService = service
  return service
}

export function chineseChatSetupStillApplies(owner, token, chatRoot) {
  return owner.language === 'chinese'
    && owner.chineseSetupToken === token
    && (!chatRoot || chatRoot.isConnected !== false)
}
